import { DEFAULT_BRAND } from '@vedalib/editor/lib/brand'
import * as R from 'ramda'

import type { BrandType } from './types'

export const mergeBrands = (parent: BrandType): BrandType => R.mergeDeepRight(DEFAULT_BRAND, parent)
